type AuditContent =
  | { kind: 'empty' }
  | { kind: 'invalid' }
  | { kind: 'value'; value: unknown }

export const parseAuditContent = (data?: string | null): AuditContent => {
  if (!data || !data.trim()) return { kind: 'empty' }
  try {
    const value: unknown = JSON.parse(data)
    return value === null ? { kind: 'empty' } : { kind: 'value', value }
  } catch {
    return { kind: 'invalid' }
  }
}
